export default {
    methods: {
        recaptcha() {
            console.log('recaptcha');

            $.getScript("https://www.google.com/recaptcha/api.js?onload=callback", () => {
                window.callback = function() {
                    grecaptcha.execute();
                };

                window.recaptcha = (arg) => {
                    this.fields.recaptcha = arg;
                };
            });
        }
    }
}